import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_27_accounting_years: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "28",
      action: "navigate_modulev1/accounting_year_mapper",
    },
    title: "Accounting years",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "name",
            Name: "bank_voucher_summary",
            BindValue: "grid_journal_voucher",
            style: {
              maxHeight: "calc(100vh - 350px)", // Adjust height to fit view
            },
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/accounting_year_mapper/<id>",
                },
                ActionType: "Edit",
                ScreenId: "28",
              },
              // {
              //   Action: {
              //     Action: "Delete",
              //     Module: "bank_voucher_summary",
              //   },
              //   ActionType: "Delete",
              //   ScreenId: "27",
              // },
            ],
            Form: {
              Name: "bank_voucher_summary",
              TableName: "vouchers",
              DisplayName: "vouchers",
              Query:
                "SELECT accounting_years.id, `lookup_items`.name ,`accounting_years`.from_date,accounting_years.to_date FROM  `accounting_years` LEFT JOIN `lookup_items` ON lookup_items.id=`accounting_years`.`accounting_year_id` WHERE lookup_items.soft_delete=0",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Accounting year",
                  BindValue: "name",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "From date",
                  IsMandatory: false,
                  BindValue: "txt_from_date",
                  Json_Attribute: "from_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "To date",
                  IsMandatory: false,
                  BindValue: "txt_to_date",
                  Json_Attribute: "to_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
